import React from 'react';
import { useTranslation } from 'react-i18next';
import { TYPE } from '../../../constant';

function SubBtn({ result, lrnEntyScnCd, className, handleGoLearningBtn }) {
  const { t } = useTranslation();
  const handleClick = (stage, lrnEntyScnCd, type) => {
    handleGoLearningBtn({ stage, lrnEntyScnCd, type })
  }

  return (
    <React.Fragment>
      {(() => {
        switch (result.lrnPrgsStsCd) {
          case TYPE.LRN_PRGS_STS_CD.LPSC04:
            return (
              <button
                className={className}
                onClick={() => handleClick(result.stgCd, lrnEntyScnCd, "replace")}
              >
                {t("LC_05_07_04.msg015")}
              </button>
            )
          case TYPE.LRN_PRGS_STS_CD.LPSC02:
            return (
              <button
                className={className}
                onClick={() => handleClick(result.stgCd, lrnEntyScnCd, "replace")}
              >
                {t("LC_05_07_02.msg015")}
              </button>
            )
          case TYPE.LRN_PRGS_STS_CD.LPSC03:
            return (
              <button
                className={className}
                onClick={() => handleClick(result.stgCd, lrnEntyScnCd, "replace" )}
              >
                {t("LC_05_07_03.msg015")}
              </button>
            )
          default:
            break;
        }
      })()}
    </React.Fragment>
  );
}

export default SubBtn;